import {
  Gender,
  TimeRegistrationType,
  TimeRegistrationStatus,
  Jobrole,
} from "../enums/enums";

export interface ILogin {
  user_id: number;
  firstname: string;
  lastname: string;
  error: string;
  token: string;
  refresh_token: string;
}

export interface IProject {
  project_id: string;
  name: string;
  hall: string;
  employees: Array<IEmployee>;
  employeeIds: Array<string>;
  is_active: boolean;
  timeRegistrationsFiltered?: Array<ITimeRegistration>;
  timeRegistrations: Array<ITimeRegistration>;
  timeRegistrationsStatus?: TimeRegistrationStatus;
  totalHours?: number;
  totalMonday?: number;
  totalTuesday?: number;
  totalWednesday?: number;
  totalThursday?: number;
  totalFriday?: number;
  totalSaturday?: number;
  operation?: string;
  king_id?: number;
}

export class Project implements IProject {
  project_id: string;
  name: string;
  hall: string;
  employees: Array<IEmployee>;
  employeeIds: Array<string>;
  is_active: boolean;
  timeRegistrationsFiltered?: Array<ITimeRegistration>;
  timeRegistrations: Array<ITimeRegistration>;
  timeRegistrationsStatus?: TimeRegistrationStatus;
  totalHours?: number;
  totalMonday?: number;
  totalTuesday?: number;
  totalWednesday?: number;
  totalThursday?: number;
  totalFriday?: number;
  totalSaturday?: number;
  operation?: string;
  king_id?: number;

  constructor(name?: string, hall?: string) {
    // this.project_id = Uuid.newUuid();
    this.name = name;
    this.hall = hall;
    this.employees = [];
    this.timeRegistrations = [];
    this.employeeIds = [];
    this.totalHours = 0;
  }
}

export interface IJobrole {
  id: string;
  Jobrole: Jobrole;
  description: string;
  timeRegistrationTypes: Array<TimeRegistrationType>;
}

export interface IEmployee {
  employee_id: string;
  approver_id: string;
  approver?: IApprover;
  first_name: string;
  middle_name: string;
  last_name: string;
  username: string;
  password?: string;
  jobroles: Array<Jobrole>;
  jobrole?: number;
  email: string;
  address?: Address;
  address_id?: string;
  phone?: string;
  gender?: Gender;
  fte: number;
  employee_number: number;
  employee_number_verloning: number;
  scholing?: boolean;
  is_not_active?: boolean;
  period_minimum?: number;
  hasProjectTimeRegistration?: boolean;
  timeRegistrationsFiltered?: Array<ITimeRegistration>;
  timeRegistrations: Array<ITimeRegistration>;
  timeRegistrations2: Array<ITimeRegistration>;
  timeRegistrations3: Array<ITimeRegistration>;
  timeRegistrations4: Array<ITimeRegistration>;
  timeRegistrationsStatus?: TimeRegistrationStatus;
  totalMonday?: number;
  totalTuesday?: number;
  totalWednesday?: number;
  totalThursday?: number;
  totalFriday?: number;
  totalSaturday?: number;
  totalHours?: number;
  totalWeek1?: number;
  totalWeek2?: number;
  totalWeek3?: number;
  totalWeek4?: number;
  totalExtraHours?: number;
  totalExtraWeek1?: number;
  totalExtraWeek2?: number;
  totalExtraWeek3?: number;
  totalExtraWeek4?: number;
  totalScholing?: number;
  totalScholingWeek1?: number;
  totalScholingWeek2?: number;
  totalScholingWeek3?: number;
  totalScholingWeek4?: number;
  totalTvt?: number;
  totalTvtWeek1?: number;
  totalTvtWeek2?: number;
  totalTvtWeek3?: number;
  totalTvtWeek4?: number;
  totalLeave?: number;
  totalLeaveWeek1?: number;
  totalLeaveWeek2?: number;
  totalLeaveWeek3?: number;
  totalLeaveWeek4?: number;
  totalSick?: number;
  totalSickWeek1?: number;
  totalSickWeek2?: number;
  totalSickWeek3?: number;
  totalSickWeek4?: number;
  projects: Array<IProject>;
  projectsFiltered?: Array<IProject>;
  leave: IProject;
  tft: IProject;
  office: IProject;
  service_transport: IProject;
  operation?: string;
  remarks?: Array<ITimeRegistration>;
  king_id?: number;
}

export class Employee implements IEmployee {
  employee_id: string;
  approver_id: string;
  approver?: IApprover;
  first_name: string;
  middle_name: string;
  last_name: string;
  username: string;
  password?: string;
  jobroles: Array<Jobrole>;
  jobrole?: number;
  email: string;
  address?: Address;
  address_id?: string;
  phone?: string;
  gender?: Gender;
  fte: number;
  employee_number: number;
  employee_number_verloning: number;
  scholing?: boolean;
  is_not_active?: boolean;
  period_minimum?: number;
  hasProjectTimeRegistration?: boolean;
  timeRegistrationsFiltered?: Array<ITimeRegistration>;
  timeRegistrations: Array<ITimeRegistration>;
  timeRegistrations2: Array<ITimeRegistration>;
  timeRegistrations3: Array<ITimeRegistration>;
  timeRegistrations4: Array<ITimeRegistration>;
  totalMonday?: number;
  totalTuesday?: number;
  totalWednesday?: number;
  totalThursday?: number;
  totalFriday?: number;
  totalSaturday?: number;
  totalHours?: number;
  totalWeek1?: number;
  totalWeek2?: number;
  totalWeek3?: number;
  totalWeek4?: number;
  totalExtraHours?: number;
  totalExtraWeek1?: number;
  totalExtraWeek2?: number;
  totalExtraWeek3?: number;
  totalExtraWeek4?: number;
  totalScholing?: number;
  totalScholingWeek1?: number;
  totalScholingWeek2?: number;
  totalScholingWeek3?: number;
  totalScholingWeek4?: number;
  totalTvt?: number;
  totalTvtWeek1?: number;
  totalTvtWeek2?: number;
  totalTvtWeek3?: number;
  totalTvtWeek4?: number;
  totalLeave?: number;
  totalLeaveWeek1?: number;
  totalLeaveWeek2?: number;
  totalLeaveWeek3?: number;
  totalLeaveWeek4?: number;
  totalSick?: number;
  totalSickWeek1?: number;
  totalSickWeek2?: number;
  totalSickWeek3?: number;
  totalSickWeek4?: number;
  timeRegistrationStatus?: TimeRegistrationStatus;
  projects: Array<IProject>;
  projectsFiltered?: Array<IProject>;
  leave: IProject;
  tft: IProject;
  office: IProject;
  service_transport: IProject;
  operation?: string;
  remarks?: Array<ITimeRegistration>;
  king_id?: number;

  constructor(first_name?: string, last_name?: string, address?: Address) {
    // this.employee_id = Uuid.newUuid();
    this.first_name = first_name;
    this.last_name = last_name;
    this.projects = [];
    this.timeRegistrations = [];
    this.totalHours = 0;
    this.fte = 40;
    this.jobroles = [Jobrole.productie];
    if (address) {
      this.address = address;
    } else {
      this.address = new Address();
    }
  }
}

export interface IApprover {
  approver_id: string;
  name?: string;
}

export interface ITimeRegistration {
  time_registration_id: string;
  project_id?: string;
  employee_id: string;
  description: string;
  type: TimeRegistrationType;
  year: number;
  week: number;
  mondayHHmm: string;
  tuesdayHHmm: string;
  wednesdayHHmm: string;
  thursdayHHmm: string;
  fridayHHmm: string;
  saturdayHHmm: string;
  status: TimeRegistrationStatus;
  remarks?: string;
  remarks_private?: string;
  remarks_check?: string;
  operation?: string;
  day?: string;
  king_id?: number;
}

export class TimeRegistration implements ITimeRegistration {
  time_registration_id: string;
  employee_id: string;
  project_id?: string;
  description: string;
  type: TimeRegistrationType;
  year: number;
  week: number;
  mondayHHmm: string;
  tuesdayHHmm: string;
  wednesdayHHmm: string;
  thursdayHHmm: string;
  fridayHHmm: string;
  saturdayHHmm: string;
  status: number;
  remarks?: string;
  remarks_private?: string;
  remarks_check?: string;
  operation?: string;
  day?: string;
  king_id?: number;

  constructor(
    employee_id: string,
    project_id: string,
    year: number,
    week: number,
    type: TimeRegistrationType,
    description?: string
  ) {
    this.employee_id = employee_id;
    this.project_id = project_id;
    this.type = type;
    this.year = year;
    this.week = week;
    this.description = description || "";
    this.mondayHHmm = "00:00";
    this.tuesdayHHmm = "00:00";
    this.wednesdayHHmm = "00:00";
    this.thursdayHHmm = "00:00";
    this.fridayHHmm = "00:00";
    this.saturdayHHmm = "00:00";
    this.status = TimeRegistrationStatus.open;
  }
}

export interface IAddress {
  address_id: string;
  street?: string;
  houseNumber?: string;
  postalCode?: string;
  city?: string;
  operation?: string;
}

export class Address implements IAddress {
  address_id: string;
  street?: string;
  house_number?: string;
  postalcode?: string;
  city?: string;
  operation?: string;

  constructor(
    street?: string,
    house_number?: string,
    postalcode?: string,
    city?: string
  ) {
    // this.address_id = Uuid.newUuid();
    this.street = street;
    this.house_number = house_number;
    this.postalcode = postalcode;
    this.city = city;
  }
}

export interface IDashboard {
  uuid: string;
  name: string;
  icon: string;
  jobRoles: Array<Jobrole>;
  dashboardItems: Array<DashboardItem>;
}

export class Dashboard implements IDashboard {
  uuid: string;
  name: string;
  icon: string;
  jobRoles: Array<Jobrole> = [];
  dashboardItems: Array<DashboardItem> = [];

  constructor(
    name?: string,
    icon?: string,
    dashboardItems?: Array<DashboardItem>
  ) {
    // this.uuid = Uuid.newUuid();
    this.name = name;
    this.icon = icon;
    if (dashboardItems) {
      this.dashboardItems = dashboardItems;
    }
  }
}

export interface IDashboardItem {
  uuid: string;
  dashboard_id: string;
  name: string;
  icon?: string;
  moduleName: string;
  jobRoles: Array<Jobrole>;
}

export class DashboardItem implements IDashboardItem {
  uuid: string;
  dashboard_id: string;
  name: string;
  icon?: string;
  moduleName: string;
  jobRoles: Array<Jobrole> = [];

  constructor(
    dashboard_id: string,
    name?: string,
    icon?: string,
    moduleName?: string
  ) {
    this.dashboard_id = dashboard_id;
    this.name = name;
    this.icon = icon;
    this.moduleName = moduleName;
  }
}

export interface ICustomer {
  uuid: string;
  name: string;
  email: string;
  address: Address;
  phone?: string;
  customerContacts?: Array<CustomerContact>;
}

export class Customer implements ICustomer {
  uuid: string;
  name: string;
  email: string;
  address: Address;
  phone?: string;
  customerContacts?: Array<CustomerContact>;

  constructor(name?: string, email?: string, address?: Address) {
    // this.uuid = Uuid.newUuid();
    this.name = name;
    this.email = email;
    this.customerContacts = [];
    if (address) {
      this.address = address;
    } else {
      this.address = new Address();
    }
  }
}

export interface ICustomerContact {
  uuid: string;
  customer_id: string;
  first_name: string;
  last_name: string;
  job_role: string;
  email: string;
  address?: Address;
  phone?: string;
  gender?: Gender;
  activeDashboards: Array<string>;
  activeDashboardItems: Array<string>;
}

export class CustomerContact implements ICustomerContact {
  uuid: string;
  customer_id: string;
  first_name: string;
  last_name: string;
  job_role: string;
  email: string;
  address?: Address;
  phone?: string;
  gender?: Gender;
  activeDashboards: Array<string>;
  activeDashboardItems: Array<string>;

  constructor(
    customer_id: string,
    first_name?: string,
    last_name?: string,
    address?: Address
  ) {
    // this.uuid = Uuid.newUuid();
    this.first_name = first_name;
    this.last_name = last_name;
    this.activeDashboards = [];
    this.activeDashboardItems = [];
    this.customer_id = customer_id;
    if (address) {
      this.address = address;
    } else {
      this.address = new Address();
    }
  }
}

/**
 * Helper class to generate temporary UUID.
 *
 */
export class Uuid {
  /**
   * This is likely to be unique and not definite. Use only form temporary use, not in DB storage!!!
   */
  static newUuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
      c
    ) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}



// WEBPACK FOOTER //
// ./src/model/top.model.ts